/* eslint-disable import/prefer-default-export */
export const getStatusCode = (state) => state.status.code;
